// Generic message to filter required errors in Yup validations
export const REQUIRED_GENERIC_HIDDEN_MESSAGE = "this-value-will-not-be-shown";
